<template>
  <v-progress-circular v-if="loading" indeterminate size="12" width="2" color="grey" class="ml-1"></v-progress-circular>
  <!-- Fator sem iniciativas não mostra indicador, para não poluir a matriz -->
  <v-menu
    v-else-if="initiatives.length > 0"
    v-model="preview"
    open-on-hover
    :open-on-click="false"
    :open-delay="300"
    :disabled="isTouch"
    offset-y
    max-width="320"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-chip
        x-small
        outlined
        color="purple"
        class="ml-1 px-1 initiative-badge"
        v-bind="attrs"
        v-on="on"
        @click.stop="open"
      >
        <v-icon x-small left class="mr-1">mdi-rocket-launch</v-icon>{{ initiatives.length }}
      </v-chip>
    </template>
    <!-- Prévia usa os dados já carregados: passar o mouse não faz requisição -->
    <v-card class="pa-2">
      <div class="caption font-weight-bold mb-1">{{ $tc('swot.linkedInitiatives', initiatives.length, { n: initiatives.length }) }}</div>
      <div v-for="item in initiatives.slice(0, 3)" :key="item.id" class="d-flex align-center caption mb-1">
        <span class="text-truncate mr-2" style="max-width: 200px;">{{ item.goal }}</span>
        <v-spacer></v-spacer>
        <v-chip x-small label dark :color="statusColor(item.status)">{{ item.status }}</v-chip>
      </div>
      <div v-if="initiatives.length > 3" class="caption grey--text">{{ $t('swot.moreInitiatives', { n: initiatives.length - 3 }) }}</div>
      <div class="caption grey--text mt-1">{{ $t('swot.clickToDetail') }}</div>
    </v-card>
  </v-menu>
</template>

<script>
import { initiativeStatusColor } from '@/helper/initiativeStatus';

export default {
  name: 'FactorInitiativesBadge',
  props: {
    initiatives: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false }
  },
  data() {
    return { preview: false };
  },
  computed: {
    // No celular/tablet não há hover: o toque abre direto o painel
    isTouch() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  },
  methods: {
    statusColor: initiativeStatusColor,
    open() {
      this.preview = false;
      this.$emit('open');
    }
  }
};
</script>

<style scoped>
.initiative-badge {
  cursor: pointer;
  flex: 0 0 auto;
}
</style>
